// src/App.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import PrivateRoute from "./components/PrivateRoute";
import EditCountry from "./pages/EditCountry";
import CountryDetail from "./pages/CountryDetail";
import EditDealer from "./pages/EditDealer";
import DealerDetail from "./pages/DealerDetail";
import EditSalesTraining from "./pages/EditSalesTraining";
import EditTechnicalSupport from "./pages/EditTechnicalSupport";
import EditInventoryAudit from "./pages/EditInventoryAudit";
import EditMarketConditions from "./pages/EditMarketConditions";
import EditCustomerSatisfaction from "./pages/EditCustomerSatisfaction";
import EditInstallationAudit from "./pages/EditInstallationAudit";
import EditFinancialData from "./pages/EditFinancialData";
import EditDealerSupportNeeds from "./pages/EditDealerSupportNeeds";
import EditDealerMarketingSupport from "./pages/EditDealerMarketingSupport";
import EditFeedback from "./pages/EditFeedback";
import EditFinalSummary from "./pages/EditFinalSummary";
import EditContact from "./pages/EditContact";
import EditEvent from "./pages/EditEvent";
import EditRiskAssessment from "./pages/EditRiskAssessment";
import EditCropAssessment from "./pages/EditCropAssessment";
import EditFieldResearch from "./pages/EditFieldResearch";
import EditAdditionalNotes from "./pages/EditAdditionalNotes";

const App: React.FC = () => {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<Login />} />

      {/* Protected */}
      <Route element={<PrivateRoute />}>        
        <Route path="/" element={<Dashboard />} />
        <Route path="/edit-country" element={<EditCountry />} />
        <Route path="/country/:id" element={<CountryDetail />} />
        <Route path="/country/:id/add-dealer" element={<EditDealer />} />
        <Route path="/dealer/:id" element={<DealerDetail />} />
        <Route
          path="/dealer/:id/edit-sales-training"
          element={<EditSalesTraining />}
        />
        <Route
          path="/dealer/:id/edit-technical-support"
          element={<EditTechnicalSupport />}
        />
        <Route
          path="/dealer/:id/edit-inventory-audit"
          element={<EditInventoryAudit />}
        />
        <Route
          path="/dealer/:id/edit-market-conditions"
          element={<EditMarketConditions />}
        />
        <Route
          path="/dealer/:id/edit-customer-satisfaction"
          element={<EditCustomerSatisfaction />}
        />
        <Route
          path="/dealer/:id/edit-installation-audit"
          element={<EditInstallationAudit />}
        />
        <Route
          path="/dealer/:id/edit-financial-data"
          element={<EditFinancialData />}
        />
        <Route
          path="/dealer/:id/edit-dealer-support-needs"
          element={<EditDealerSupportNeeds />}
        />
        <Route
          path="/dealer/:id/edit-dealer-marketing-support"
          element={<EditDealerMarketingSupport />}
        />
        <Route
          path="/dealer/:id/edit-feedback"
          element={<EditFeedback />}
        />
        <Route
          path="/dealer/:id/edit-final-summary"
          element={<EditFinalSummary />}
        />
        <Route
          path="/country/:id/edit-contact"
          element={<EditContact />}
        />
        <Route path="/country/:id/edit-event" element={<EditEvent />} />
        <Route
          path="/country/:id/edit-risk-assessment"
          element={<EditRiskAssessment />}
        />
        <Route
          path="/country/:id/edit-crop-assessment"
          element={<EditCropAssessment />}
        />
        <Route
          path="/country/:id/edit-field-research"
          element={<EditFieldResearch />}
        />
        <Route
          path="/country/:id/edit-additional-notes"
          element={<EditAdditionalNotes />}
        />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
